import { render, staticRenderFns } from "./SavedContentItem.vue?vue&type=template&id=69cbd0de&scoped=true&"
import script from "./SavedContentItem.vue?vue&type=script&lang=js&"
export * from "./SavedContentItem.vue?vue&type=script&lang=js&"
import style0 from "./SavedContentItem.vue?vue&type=style&index=0&id=69cbd0de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cbd0de",
  null
  
)

export default component.exports